import classNames from "classnames/bind";
import styles from "./StreamCamera.module.css";
import LiveVideo from "./LiveVideo";
import TablePlate from "./TablePlate";
import DetailInfo from "./DetailInfo";
import { Col, Pagination, Row } from "../../../../../components";
import { useContext, useState, useEffect } from "react";
import { LisencePlateContext } from "../../../../../contexts";

const cx = classNames.bind(styles);

const StreamCamera = ({ listObject, data, showPagination, currentPage, totalPage, handleChosePage, handleNextPage, handlePrevPage }) => {
  const { screen, showInfo, info } = useContext(LisencePlateContext);
  // const [listObject, setListObject] = useState([]);
  // // // console.log(data);
  // useEffect(() => {
  //   setListObject([])
  //   const eventSource = new EventSource(
  //     `${process.env.REACT_APP_FSR_IP}/server-events/stream-sse?camera_code=${data?.code}`

  //   );
  //   eventSource.onmessage = (event) => {
  //     // // console.log(event);
  //     // if (JSON.parse(event.data).camera_code === '20240505000000000001') {
  //     const objects = JSON.parse(event.data)
  //     // setListObject(objects);
  //     if (listObject.length <= 20) {
  //       setListObject(pre => [objects, ...pre])
  //     } else {
  //       const max = listObject.length;
  //       const data = listObject.filter((item, index) => index < max);
  //       setListObject([
  //         objects,
  //         ...data,
  //       ]);
  //     }
  //   }
  //   eventSource.onerror = (error) => {
  //     eventSource.close();
  //   };
  //   return () => {
  //     eventSource.close();
  //   };
  // }, [data?.code]);
  return (
    <div className={cx("container")}>
      <Row gap={[8, 8]} >
        <Col span={7}>
          <LiveVideo data={data} />
          {showPagination && (
            <div className={cx("pagination")}>
              <Pagination
                pages={totalPage}
                currentPage={currentPage}
                onClick={handleChosePage}
                onNext={handleNextPage}
                onPrevious={handlePrevPage}
              />
            </div>
          )}
          {screen && screen.total <= 2 && showInfo && (
            <DetailInfo info={info} />
          )}
        </Col>
        <Col span={5}>
          <TablePlate data={listObject} nameCamera={data ? data?.name : ''} />
        </Col>
      </Row>
    </div>
  );
};

export default StreamCamera;
